export const SET_FILTERS_FROM_QUERY_PARAMS = 'SET_FILTERS_FROM_QUERY_PARAMS';
export const SET_QUERY_PARAMS_FROM_FILTERS = 'SET_QUERY_PARAMS_FROM_FILTERS';
export const RESET_FILTERS_QUERY_PARAMS = 'RESET_FILTERS_QUERY_PARAMS';
